let switchErrors = function(error, componente, excepciones = []) {
  let mensaje = "";
  let titulo = "";
  let tipo = "onError";
  let dobleBotonera = false;
  let ayuda = false;
  let codigo = null;
  let excepcion = null;
  if (error && (error.data || error.response || error.status)) {
    if (excepciones.length > 0) {
      let codigoError = error.status || error.response.status;
      excepcion = excepciones.find(excepcionTemp => {
        return "" + excepcionTemp.codigo === "" + codigoError;
      });
      if (excepcion) {
        mensaje = excepcion.mensaje;
        codigo = excepcion.codigo;
        if (codigo == 503) {
          tipo = "onAlerta";
          titulo = "";
        }
      }
    }
    if (!excepcion) {
      switch (error.status || error.response.status) {
        case 204:
          titulo = "Registro fallido";
          mensaje = "Por favor intenta de nuevo";
          break;
        case 401:
          if (error.data && error.data.errores) {
            let values = Object.keys(error.data.errores).map(function(key) {
              return dictionary[key];
            });
            mensaje = values[0];
          } else if (error.response && error.response.data) {
            if (error.response.data.errors) {
              mensaje = error.response.data.errors[0].defaultMessage;
            } else if (error.response.data.intentosRestantes > 0) {
              mensaje =
                "Contraseña incorrecta, intentos restantes: " +
                error.response.data.intentosRestantes;
            } else if (
              error.response.data &&
              error.response.data.intentosRestantes == 0
            ) {
              mensaje =
                "Ha superado los intentos para ingresar su contraseña. Vaya a la sección “Olvidé mi contraseña” para recuperarla.";
            } else if (
              error.response.data &&
              error.response.data.intentosRestantes == undefined
            ) {
              mensaje =
                "Asegurate de ingresar tu RUN con guión y dígito verificador, y tu contraseña exactamente como la registraste.";
            }
          }
          break;
        case 406:
          titulo = "Error para Iniciar Sesión";
          mensaje =
            "Asegurate de ingresar tu RUN con guión y dígito verificador, y tu contraseña exactamente como la registraste.";
          break;
        case 404:
          titulo = "No encontrado";
          tipo = "onAlerta";
          mensaje =
            "Los datos no han sido encontrados, por favor recargar la página y reintentar";
          break;
        case 400:
          if (error.data && error.data.errores) {
            let values = Object.keys(error.data.errores).map(function(key) {
              return dictionary[key];
            });
            mensaje = values[0];
          } else if (error.response && error.response.data) {
            if (error.response.data.errors) {
              mensaje = error.response.data.errors[0].defaultMessage;
            } else if (error.response.data.errores) {
              let values = Object.keys(error.response.data.errores).map(
                function(key) {
                  return error.response.data.errores[key][0];
                }
              );
              mensaje = values[0];
            }
            let idx = mensaje.indexOf("recuperar contraseña");
            if (idx != -1) {
              codigo = 700;
            }
          }
          break;
        case 409:
          titulo = "Este RUN ya está registrado";
          tipo = "onAlerta";
          mensaje =
            "Si recuerdas tu clave Inicia sesión, de lo contrario recupera tu contraseña";
          dobleBotonera = true;
          break;
        case 500:
          titulo = "Error";
          if (componente.$el.id === "Inicio") {
            mensaje =
              "No se ha podido ingresar al sistema de admisión, por favor intentar de nuevo.";
          } else if (componente.$el.id === "Registro") {
            titulo = "Registro fallido";
            tipo = "onAlerta";
            mensaje = "Por favor intenta de nuevo";
          } else {
            mensaje =
              "No se ha podido realizar la operación, por favor intentar de nuevo.";
            ayuda = true;
          }
          break;
        case 503:
          titulo = "El sistema está teniendo alta demanda";
          mensaje =
            "No te preocupes, vuelve a intentarlo más tarde. <br>Mientras, revisa los colegios a los que postularás.<br><a href='/vitrina-vue' target='_self' style='text-decoration: underline;  font-weight: bold;'>VER ESTABLECIMIENTOS</a>";
          break;
        default:
          titulo = "El sistema está teniendo alta demanda";
          mensaje =
            "No te preocupes, vuelve a intentarlo más tarde. <br>Mientras, revisa los colegios a los que postularás.<br><a href='/vitrina-vue' target='_self' style='text-decoration: underline;  font-weight: bold;'>VER ESTABLECIMIENTOS</a>";
      }
    }
  } else {
    if (error.message) {
      mensaje = error.message;
    } else {
      mensaje =
        "No te preocupes, vuelve a intentarlo más tarde. Mientras, revisa los colegios a los que postularás. <a href='/vitrina-vue' target='_self' style='text-decoration: underline;  font-weight: bold;'> VER ESTABLECIMIENTOS</a>";
    }
  }
  if (mensaje.length > 0) {
    componente.$emit(tipo, mensaje, titulo, dobleBotonera, ayuda, codigo);
  } else {
    console.warn("Error sin mensaje");
  }
};

export default { switchErrors };



// WEBPACK FOOTER //
// ./src/utils/Errores.js